import { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../../services/api";
import "./notice.css";

export default function AddNotice() {
  const school   = JSON.parse(localStorage.getItem("schoolAdmin"));
  const navigate = useNavigate();

  const [form,   setForm]   = useState({ title: "", message: "" });
  const [file,   setFile]   = useState(null);
  const [saving, setSaving] = useState(false);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.title || !form.message) return alert("Title and Message are required");
    try {
      setSaving(true);
      const fd = new FormData();
      fd.append("title",   form.title);
      fd.append("message", form.message);
      if (file) fd.append("file", file);
      await API.post("/school-admin/notices/add/", fd, {
        headers: { "X-SCHOOL-ID": school.school.id, "Content-Type": "multipart/form-data" },
      });
      navigate("/school-admin/notices");
    } catch (err) { console.error(err); alert("Failed to create notice"); }
    finally { setSaving(false); }
  };

  return (
    <div className="nt-page">

      {/* ══ HERO ══ */}
      <div className="nt-hero">
        <div className="nt-hero-left">
          <div className="nt-hero-icon">📢</div>
          <div>
            <h2 className="nt-hero-title">Add Notice</h2>
            <p className="nt-hero-sub">Publish a new announcement for students and staff</p>
          </div>
        </div>
        <div className="nt-hero-right">
          <button className="nt-btn-back" onClick={() => navigate("/school-admin/notices")}>
            ← Back
          </button>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="nt-form-card">
          <p className="nt-form-section-title">Notice Details</p>

          {/* Title */}
          <div className="nt-field">
            <label>Notice Title *</label>
            <input
              required
              placeholder="e.g. Holiday Announcement, Exam Schedule"
              value={form.title}
              onChange={e => set("title", e.target.value)}
            />
          </div>

          {/* Message */}
          <div className="nt-field">
            <label>Message *</label>
            <textarea
              required
              placeholder="Write the full notice content here…"
              value={form.message}
              onChange={e => set("message", e.target.value)}
            />
          </div>

          {/* File upload */}
          <div
            className="nt-file-zone"
            onClick={() => document.getElementById("nt-file-input").click()}
          >
            <div className="nt-file-zone-label">📎 Attachment (PNG / JPG / PDF)</div>
            <div className="nt-file-zone-hint">Click to browse — optional</div>
            {file && <div className="nt-file-name">{file.name}</div>}
            <input
              id="nt-file-input"
              type="file"
              accept=".png,.jpg,.jpeg,.pdf"
              hidden
              onChange={e => setFile(e.target.files[0] || null)}
            />
          </div>

          <button type="submit" className="nt-btn-submit" disabled={saving}>
            {saving
              ? <><div className="nt-spinner"></div> Saving…</>
              : "✓ Publish Notice"
            }
          </button>
        </div>
      </form>

    </div>
  );
}
